<div
  *ngIf="open"
  class="wrapper-base-modal"
  [ngClass]="{ 'size-small': size === 'small' }"
  [style.z-index]="zIndex"
>
  <div class="container" [ngClass]="{ 'is-mobile': isMobile }">
    <app-shared-icon
      name="close"
      class="close-icon"
      [size]="14"
      (click)="onCloseHandler()"
    ></app-shared-icon>

    <header *ngIf="!!name">
      <h4 class="flex items-start gap-x-1.5">
        <ng-icon
          *ngIf="nameIcon"
          [name]="nameIcon.name"
          [class]="'mt-2.5 ' + nameIcon.class"
        ></ng-icon>
        {{ name }} <sup *ngIf="sup">{{ sup }}</sup>
      </h4>
    </header>

    <div
      class="content"
      [ngClass]="{ '!pb-0': slug === 'review-cbsa-preferences' }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
